export default function PHP_restore_exception_handler() {
  return (
    <div>
      <h1>PHP_restore_exception_handler</h1>
    </div>
  );
}
